module.exports = __webpack_public_path__ + "static/media/11NEPAD4.80d39d09.jpg";